import React from 'react'
import Modal from '../components/modal'
import {
    S_SPORTUJ_V_OSTRAVE,
    S_SPORTUJ_V_OLOMOUCI,
    ROLE_ADMIN,
    ROLE_OSTRAVA_ADMIN,
    S_SPORTUJ_V_CHEBU,
    ROLE_CHEB_ADMIN,
    SYSTEM_BY_ROLE_ID,
} from '../consts'
import { nameAcronym } from '../components/shared/name-acronym'
import Link from '../front/components/shared/sn-link'

/**
 * Pass city based to system
 * @param {string} system
 * @returns {*}
 */
export const getCityBySystem = system => {
    switch (system) {
        case S_SPORTUJ_V_OSTRAVE: return 'ostrava'
        case S_SPORTUJ_V_OLOMOUCI: return 'olomouc'
        case S_SPORTUJ_V_CHEBU: return 'cheb'
        default: return null
    }
}

/**
 * Renders target user image
 * @param {Object} user
 * @returns {*}
 */
export const renderUserImage = user => {
    let imageDataOrNull = user.avatar || null
    const acronym = nameAcronym(`${user.name} ${user.surname}`)

    if (imageDataOrNull) {
        return (
            <div className="Group-detail__members-box-content-logo-image">
                <img src={imageDataOrNull} alt="" />
            </div>
        )
    }

    return (
        <div className="Group-detail__members-box-content-logo-text">
            {acronym}
        </div>
    )
}

/**
 * Render a modal owner and managers
 * @returns {*}
 */
export const renderModalOwner = (showModalOwner, entity, toggleOwnerModal) => {
    if (!showModalOwner) {
        return null
    }

    return (
        <Modal
            content={() =>
                <div className="p-4">
                    {entity.owner && entity.owner.data &&
                        <div className="card">
                            <h5 className="card-header">Vlastník</h5>
                            <div className="card-body d-flex flex-row align-items-center">
                                <div className="mr-3">{renderUserImage(entity.owner.data)}</div>
                                <div>
                                    <h5 className="card-title"><Link className="mr-2" to={entity.owner.data.profile_link}>{entity.owner.data.name} {entity.owner.data.surname}</Link></h5>
                                    <p className="card-text"><a href={`mailto:${entity.owner.data.email}`}>({entity.owner.data.email})</a></p>
                                </div>
                            </div>
                        </div>
                    }
                    {entity.managers && entity.managers.data &&
                        <div className="card">
                            <h5 className="card-header">Správci</h5>
                            {entity.managers.data.map(manager => (
                                <div className="card-body d-flex flex-row align-items-center" key={`manager-${manager.id}`}>
                                    <div className="mr-3">{renderUserImage(manager)}</div>
                                    <div>
                                        <h5 className="card-title"><Link to={manager.profile_link} className="mr-2">{manager.name} {manager.surname}</Link></h5>
                                        <p className="card-text"><a href={`mailto:${manager.email}`}>({manager.email})</a></p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                </div>
            }
            handleHideModal={toggleOwnerModal}
            description={entity.name}
        />
    )
}

/**
 * Removes target actuality
 * @param {Object} actuality
 * @param {string} redirect
 * @returns {Promise<unknown>}
 */
export const removeActuality = (actuality, redirect = null) => (
    window.axios.delete(`${window.APP_CONFIG.REACT_APP_API_URL}api/news/${actuality.slug}`).then(() => {
        if (redirect === false) {
            return new Promise(resolve => resolve())
        }

        if (redirect) {
            window.location.href = redirect
            return
        }
        window.location.reload()
    })
)

/**
 * Toggle sort
 * @param _that
 * @param sort
 */
export const changeSort = (_that, sort) => new Promise(dispatch => {
    const stateSort = _that.state.sort

    const splitted = stateSort.split('|')

    let newOrder = 'desc'
    let newSort = ''

    if (splitted[0] === sort) {
        switch (splitted[1]) {
            case 'desc':
                newOrder = 'asc'
                break
            case 'asc':
                newOrder = ''
                break
            default: break
        }
    }

    if (newOrder !== '') {
        newSort = `${sort}|${newOrder}`
    }

    _that.setState({
        sort: newSort,
        page: 1,
    }, () => dispatch())
})

/**
 * Renders specified date in preset format
 * @param {Object} date
 * @returns {null|*}
 */
export const renderDate = date => {
    if (!date) {
        return null
    }

    const calendar = moment(date).calendar()
    const day = moment(date).format('DD.MM.YYYY')
    const formatted = moment(date).format('dd D.M.YYYY HH:mm')

    if (calendar === day) {
        return formatted
    }

    return <span>{calendar}<br/><small>{formatted}</small></span>
}

/**
 * Checks whether user is a super admin
 * @param {Object} user
 * @returns {boolean}
 */
export const isSuperAdmin = user => {
    if (!user) {
        return false
    }

    return user.role_id === ROLE_ADMIN
}

/**
 * Checks whether user is Ostrava admin
 * @param {Object} user
 * @returns {boolean}
 */
export const getSystemByAdmin = user => {
    if (!user) {
        return false
    }

    return SYSTEM_BY_ROLE_ID[user.role_id] || null
}

/**
 * Checks whether user can admin specified system
 * @param {Object} user
 * @param {string} system
 */
export const canAdminSystem = (user, system) => {
    if (isSuperAdmin(user)) {
        return true
    }

    return SYSTEM_BY_ROLE_ID[user.role_id] === system
}

/**
 * Checks whether user is an admin
 * @param {Object} user
 * @returns {boolean}
 */
export const isAdmin = user => {
    if (!user) {
        return false
    }

    return isSuperAdmin(user) || user.role_id === ROLE_OSTRAVA_ADMIN || user.role_id === ROLE_CHEB_ADMIN
}
